import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import {
	type MenuNode,
	MenuNodeType,
} from '@atlassian/jira-software-context-menu/src/common/types.tsx';
import { CHANGE_TEAM_MENU_ID, CHANGE_TEAM_SEARCH_MENU_ID } from '../../constants.tsx';
import messages from '../../messages.tsx';
import type { ContentProps } from './types.tsx';
import changeTeamMessages from './messages.tsx';

export const useChangeTeamContent = ({ setQuery, options }: ContentProps): MenuNode[] => {
	const { formatMessage } = useIntl();

	const subMenu = fg('plans_program_board_a11y_fixes')
		? {
				type: MenuNodeType.Search,
				id: CHANGE_TEAM_SEARCH_MENU_ID,
				children: options,
				hasSearch: true,
				isLoading: false,
				onChange: setQuery,
				ariaLabel: fg('jpo_a11y_pb_fixes')
					? formatMessage(changeTeamMessages.teamSearchLabel)
					: undefined,
				isAsyncSearch: false,
			}
		: [
				{
					type: MenuNodeType.Search,
					id: CHANGE_TEAM_SEARCH_MENU_ID,
					children: options,
					hasSearch: true,
					isLoading: false,
					onChange: setQuery,
					ariaLabel: fg('jpo_a11y_pb_fixes')
						? formatMessage(changeTeamMessages.teamSearchLabel)
						: undefined,
					isAsyncSearch: false,
				},
			];

	return [
		{
			type: MenuNodeType.Item,
			label: formatMessage(messages.changeTeam),
			id: CHANGE_TEAM_MENU_ID,
			submenuWidth: 284,
			children: subMenu,
		},
	];
};
